import React from 'react'
import {Component} from 'react'
import { css } from 'glamor'
import {SCREENXSMAX} from '/js/variables/breakpoints'
import CommunityInfo from '../community-info'
import DateNav from '../datenav'
import {DateTime} from 'luxon'
import EventProgram from '../event-program'
import Linkify from '../linkify'
import LocationSelector from '../location-selector'
import MapLink from '../map-link'
import MarketsIndex from '../markets-index'
import PageHeader from '../page-header'
import SharingButtons from '../sharing-buttons'
import getImageSize from '../../functions/get-image-size'
import Days from '../winter-walk/days'
import VendorsIndex from '../vendors-index'
import './location.scss'

class EventSelector extends Component {
  render(){
    let currentLocation = this.props.currentLocation
    console.log(this.props);
    return (
      <div className={this.props.className}>
        <LocationSelector
          currentLocation={currentLocation}
          locations={this.props.locations}
          setLocation={this.props.setLocation}
        />
        { ( currentLocation && Array.isArray(currentLocation.events) ) &&
          <DateNav
            events={ currentLocation.events }
            setEvent={ this.props.setEvent }
            event={ this.props.currentEvent }
            pageLength={ window.innerWidth < SCREENXSMAX ? 1 : 3 }
          />
        }
      </div>
    )
  }
}

class Upcoming extends Component {
  render(){
    if( Array.isArray(this.props.events) && this.props.events[0] ){
      let location = this.props.events[0].location

      return (
        <div className="upcoming-events">
          <h4>
            <MapLink
              latitude={location.latitude}
              longitude={location.longitude}
              text={this.props.events[0].name}
            />
          </h4>
          <Days days={this.props.events.byDate()} />
        </div>
      )
    } else {
      return null
    }
  }
}

export default class extends Component {
  state = { currentLocation: this.props.north }
  setCurrentEvent = event => {
    if( event ){
      
      let date = DateTime.fromString( event.date, 'yyyy-M-d' )
      
      event.fetchDetails()
      .always( ()=>{
        let programs = LOCATION_EXTRAS['specialPrograms'];
        
        this.setState({
          currentEvent: event,
          currentProgram: programs[date.toFormat('yyyy-MM-dd')],
        })
      })
    }
  }
  setCurrentLocation = l => {
    let event = l.events[0]
    this.setState(
      { currentLocation: l },
      ()=>{ this.setCurrentEvent( event ) }
    )
  }
  render() {
    let north = this.props.north
    let south = this.props.south

    return (
      <div className="location">
        <PageHeader
          backgroundImage={ getImageSize( '--medium', north.imageUrl ) }
          heading={ LOCATION_EXTRAS['heroHeading'] ? LOCATION_EXTRAS['heroHeading'] : 'Emperor Norton\'s Holiday Bazaar' }
        />
        <Linkify tagName="div" className={ `location__about location__section ${css({ margin: '40px 0'})}`}>{north.about}</Linkify>
        <EventProgram className="location__event-selector location__section"{ ...this.state.currentProgram } />
        <CommunityInfo
          className="location__section location__community-info"
          event={this.state.currentEvent}
        />
        <EventSelector
          className="location__section"
          currentLocation={this.state.currentLocation}
          currentEvent={this.state.currentEvent}
          locations={[ north, south ]}
          setLocation={ l => { this.setCurrentLocation( l )} }
          setEvent={ event =>{ this.setCurrentEvent( event ) } }
        />
        { this.state.currentEvent && this.state.currentEvent.vendors &&
          <div className="location__section">
            <h2>Vendors</h2>
            <VendorsIndex compactGrid={true} vendors={ this.state.currentEvent.vendors } />
          </div>
        }
        <section className="location__section location__upcoming">
          <div className="location__upcoming__header">
            <h2 className="location__upcoming__heading">Upcoming Events</h2>
            <SharingButtons
              className="location__upcoming__sharing-buttons"
              shareText={ "Meet me at Winter Walk!"}
              market={ north }
            />
          </div>
          { ( Array.isArray(north.events) && north.events.length > 0 || Array.isArray(south.events) && south.events.length > 0 ) ?
            <div key='events' className="location__events">
              { north.events && <Upcoming events={north.events} /> }
              { south.events && <Upcoming events={south.events} />}
            </div> :
            <div>No upcoming events found - check back later!</div>
          }
        </section>
        <section className="location__section">
          <h2 className="highlight">Browse More Markets</h2>
          <MarketsIndex
            hideDistanceFilter={true}
            excludeMarket={ [north.slug, south.slug] }
            location={ { lat: north.latitude, lng: north.longitude } }
          />
        </section>
      </div>
    )
  }
}
